import { observer } from 'mobx-react-lite'
import { type FC, useEffect } from 'react'
import { Table } from 'shared/ui/TableNew'
import { type ContactsDuplicateTableStore } from 'pages/contacts/pages/cleanup/ui/ContactsDuplicateTable'
import { columns } from './columns'
import styles from './styles.module.scss'

type IContactsDuplicateTableProps = {
  store: ContactsDuplicateTableStore
}

export const ContactsDuplicateTable: FC<IContactsDuplicateTableProps> = observer(({ store }) => {
  const { list, tableStore, init, dispose } = store

  useEffect(() => {
    init()

    return () => {
      dispose()
    }
  }, [])

  return (
    <div className={styles.tableContainer}>
      <Table
        ariaLabel={'ContactsDuplicateTable'}
        store={tableStore}
        virtualization
        emptyStateProps={{
          text: 'No duplicate contacts found',
        }}
        sxBox={{ padding: '0 16px' }}
        columns={columns(store)}
        rows={list}
      />
    </div>
  )
})
